import React, { ReactNode, useState } from 'react';

/**
 * Sklopiva "Novi …" kartica za admin module — sakriva formu po defaultu.
 * Otvara se klikom na "+ Novi …" gumb. Ujednačeno preko cijele administracije.
 */
export function AdminCreateCard({
    title,
    hint,
    children,
    locale,
    defaultOpen = false,
}: {
    title: string;
    hint?: string;
    children: ReactNode;
    locale?: 'hr' | 'en';
    defaultOpen?: boolean;
}) {
    const [open, setOpen] = useState(defaultOpen);
    const lang = locale ?? 'hr';
    return (
        <div className="admin-create-card" style={{ marginBottom: '1.25rem' }}>
            <button
                type="button"
                className={open ? 'compact' : 'secondary compact'}
                onClick={() => setOpen((v) => !v)}
                aria-expanded={open}
                style={{ marginBottom: open ? '0.75rem' : 0 }}
            >
                {open
                    ? (lang === 'en' ? `▾ Close: ${title}` : `▾ Zatvori: ${title}`)
                    : (lang === 'en' ? `+ ${title}` : `+ ${title}`)}
            </button>
            {open ? (
                <div className="admin-create-card-body nested-card" style={{ padding: '1rem 1.1rem' }}>
                    {hint ? (
                        <p className="muted" style={{ marginTop: 0, marginBottom: '0.85rem', fontSize: '0.9rem', lineHeight: 1.45 }}>
                            {hint}
                        </p>
                    ) : null}
                    {children}
                </div>
            ) : null}
        </div>
    );
}
